module.exports = __webpack_public_path__ + "static/media/product_detail_1.7f4b65ef.jpg";